import _ from 'lodash'

export default {
  // TODO: Entity Dream
  allDreams: (state) => state.dreams || [],
  allDreamsDone: (state, getters) => _.filter(getters.allDreams, (d) => d.progress >= 100),
  dreams: (state, getters) => _.chain(getters.allDreams)
    .orderBy(['order', 'progress'], ['asc', 'desc'])
    .value(),
  dreamsById: (state, getters) => _.mapKeys(getters.allDreams, 'id'),
  currentDreams: (state, getters) => _.chain(getters.goalsByPeriod(getters.currentPeriod))
    .orderBy(['order', 'asc'])
    .map((g) => getters.dreamsById[g.dreamId]) // { done: g.progress === 100 })) // TODO: not working when d.currentGoals > 1
    .reject((d) => !d)
    .uniqBy((d) => d.id)
    .value()
}
